define('OutSystems/ClientRuntime/Model',["require", "exports", "tslib", "./DataConversion", "./DataTypes", "./Logger", "./WidgetNaming"], function (require, exports, tslib_1, DataConversion_1, DataTypes_1, Logger, WidgetNaming_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ModelFactory = exports.DummyViewModel = exports.VariablelessViewModel = exports.calculateDataFetchStatus = exports.BaseViewModel = exports.AggregateRecord = exports.DataSourceRecord = exports.BaseWidgetRecordMap = exports.ValidationWidgetRecord = exports.WidgetRecord = exports.Variable = void 0;
    var WIDGET_RECORD_ID_ATTR = "idAttr";
    var WIDGET_RECORD_NAME_ATTR = "nameAttr";
    var VALIDATION_WIDGET_RECORD_VALID_ATTR = "validAttr";
    var VALIDATION_WIDGET_RECORD_VALIDATIONMSG_ATTR = "validationMessageAttr";
    var Variable = (function () {
        function Variable(type, _value, setter, model) {
            this.type = type;
            this._value = _value;
            this.setter = setter;
            this.model = model;
        }
        Object.defineProperty(Variable.prototype, "value", {
            get: function () {
                return this._value;
            },
            set: function (value) {
                var convertedValue = DataConversion_1.JSConversions.convertTo(value, this.type);
                this.setter(convertedValue);
                this.model.flush();
            },
            enumerable: false,
            configurable: true
        });
        Variable.prototype.isAcceptable = function (value) {
            return DataConversion_1.JSConversions.isConvertibleTo(value, this.type);
        };
        Variable.prototype.fastEquals = function (other) {
            return other && this.constructor === other.constructor && this.value === other.value;
        };
        Variable.prototype.equals = function (other) {
            return other && this.constructor === other.constructor && (0, DataTypes_1.equals)(this.value, other.value);
        };
        return Variable;
    }());
    exports.Variable = Variable;
    var WidgetRecord = (function (_super) {
        tslib_1.__extends(WidgetRecord, _super);
        function WidgetRecord(defaults) {
            return _super.call(this, defaults) || this;
        }
        Object.defineProperty(WidgetRecord.prototype, "idAttr", {
            get: function () {
                return this.getBasicProperty(WIDGET_RECORD_ID_ATTR);
            },
            set: function (value) {
                this.setBasicProperty(WIDGET_RECORD_ID_ATTR, value, DataTypes_1.DataTypes.Text);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(WidgetRecord.prototype, "nameAttr", {
            get: function () {
                return this.getBasicProperty(WIDGET_RECORD_NAME_ATTR);
            },
            set: function (value) {
                this.setBasicProperty(WIDGET_RECORD_NAME_ATTR, value, DataTypes_1.DataTypes.Text);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(WidgetRecord.prototype, "generationNode", {
            get: function () {
                return this.getBasicProperty(WidgetRecord.WidgetGenerationNodeAttributeName);
            },
            set: function (node) {
                this.setBasicProperty(WidgetRecord.WidgetGenerationNodeAttributeName, node, DataTypes_1.DataTypes.Object);
            },
            enumerable: false,
            configurable: true
        });
        WidgetRecord.prototype.asReadOnly = function () {
            return {
                idAttr: this.idAttr,
                nameAttr: this.nameAttr,
            };
        };
        WidgetRecord.prototype.refreshGeneration = function () {
            if (this.generationNode) {
                this.generationNode.generation = GenerationsTree.currentGeneration;
            }
        };
        WidgetRecord.WidgetGenerationNodeAttributeName = "widgetGenerationNode";
        WidgetRecord.RecordClass = DataTypes_1.Record.defineRecordClass({
            idAttr: "",
            nameAttr: "",
            widgetGenerationNode: null,
        });
        return WidgetRecord;
    }(DataTypes_1.Record));
    exports.WidgetRecord = WidgetRecord;
    function validationWidgetRecordAsReadOnly(data) {
        return {
            idAttr: data.get(WIDGET_RECORD_ID_ATTR),
            nameAttr: data.get(WIDGET_RECORD_NAME_ATTR),
            validAttr: data.get(VALIDATION_WIDGET_RECORD_VALID_ATTR),
            validationMessageAttr: data.get(VALIDATION_WIDGET_RECORD_VALIDATIONMSG_ATTR),
        };
    }
    var ValidationWidgetRecord = (function (_super) {
        tslib_1.__extends(ValidationWidgetRecord, _super);
        function ValidationWidgetRecord(defaults) {
            return _super.call(this, defaults) || this;
        }
        Object.defineProperty(ValidationWidgetRecord.prototype, "validAttr", {
            get: function () {
                return this.getBasicProperty(VALIDATION_WIDGET_RECORD_VALID_ATTR);
            },
            set: function (value) {
                this.setBasicProperty(VALIDATION_WIDGET_RECORD_VALID_ATTR, value, DataTypes_1.DataTypes.Boolean);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValidationWidgetRecord.prototype, "validationMessageAttr", {
            get: function () {
                return this.getBasicProperty(VALIDATION_WIDGET_RECORD_VALIDATIONMSG_ATTR);
            },
            set: function (value) {
                this.setBasicProperty(VALIDATION_WIDGET_RECORD_VALIDATIONMSG_ATTR, value, DataTypes_1.DataTypes.Text);
            },
            enumerable: false,
            configurable: true
        });
        ValidationWidgetRecord.prototype.onPropertyValueChanged = function (propertyName) {
            if (propertyName === VALIDATION_WIDGET_RECORD_VALID_ATTR ||
                propertyName === VALIDATION_WIDGET_RECORD_VALIDATIONMSG_ATTR) {
                this.refreshGeneration();
            }
        };
        ValidationWidgetRecord.prototype.asReadOnly = function () {
            return validationWidgetRecordAsReadOnly(this.data);
        };
        ValidationWidgetRecord.RecordClass = (function () {
            var record = new WidgetRecord.RecordClass().toJS();
            record.validAttr = true;
            record.validationMessageAttr = "";
            return DataTypes_1.Record.defineRecordClass(record);
        })();
        return ValidationWidgetRecord;
    }(WidgetRecord));
    exports.ValidationWidgetRecord = ValidationWidgetRecord;
    var BaseWidgetRecordMap = (function (_super) {
        tslib_1.__extends(BaseWidgetRecordMap, _super);
        function BaseWidgetRecordMap(defaults) {
            var _this = _super.call(this, defaults) || this;
            _this.widgetsIdToRecord = _this.data.get(BaseWidgetRecordMap.WidgetRecordsAttribute);
            _this.widgetsIdToRecordDataCache = _this.data.get(BaseWidgetRecordMap.WidgetRecordsDataCacheAttribute);
            return _this;
        }
        BaseWidgetRecordMap.createDefaultData = function () {
            return new BaseWidgetRecordMap.RecordClass({
                records: new Map(),
                recordsCache: new Map(),
            });
        };
        BaseWidgetRecordMap.getWidgetsType = function () {
            return {};
        };
        BaseWidgetRecordMap.prototype.getWidgetsType = function () {
            return this.constructor.getWidgetsType();
        };
        BaseWidgetRecordMap.prototype.getWidgetRecordType = function (widgetName) {
            return this.getWidgetsType()[widgetName] || WidgetRecord;
        };
        BaseWidgetRecordMap.prototype.get = function (widgetId) {
            var record = this.widgetsIdToRecord.get(widgetId);
            if (record) {
                return record;
            }
            record = this.create(widgetId);
            this.add(record);
            return record;
        };
        BaseWidgetRecordMap.prototype.set = function (widgetId, widgetRecord) {
            this.widgetsIdToRecord.set(widgetId, widgetRecord);
            this.widgetsIdToRecordDataCache.delete(widgetId);
            this.writePropagate(this.data, null);
        };
        BaseWidgetRecordMap.prototype.internalSet = function (widgetId, widgetRecordData) {
            this.widgetsIdToRecord.delete(widgetId);
            this.widgetsIdToRecordDataCache.set(widgetId, widgetRecordData);
            this.writePropagate(this.data, null);
        };
        BaseWidgetRecordMap.prototype.create = function (widgetId) {
            var widgetName = WidgetNaming_1.WidgetIdService.nameFromId(widgetId);
            var recordType = this.getWidgetRecordType(widgetName);
            var recordData = this.widgetsIdToRecordDataCache.get(widgetId);
            var record = new recordType(recordData);
            record.idAttr = widgetId;
            record.nameAttr = widgetName;
            return record;
        };
        BaseWidgetRecordMap.prototype.add = function (record) {
            BaseWidgetRecordMap.setPropagationHandler(record, this, record.idAttr, this.internalSet);
            this.widgetsIdToRecordDataCache.delete(record.idAttr);
            this.widgetsIdToRecord.set(record.idAttr, record);
        };
        BaseWidgetRecordMap.prototype.remove = function (widgetId) {
            this.widgetsIdToRecord.delete(widgetId);
            this.widgetsIdToRecordDataCache.delete(widgetId);
            this.writePropagate(this.data, null);
        };
        BaseWidgetRecordMap.WidgetRecordsAttribute = "records";
        BaseWidgetRecordMap.WidgetRecordsDataCacheAttribute = "recordsCache";
        BaseWidgetRecordMap.RecordClass = DataTypes_1.Record.defineRecordClass({
            records: null,
            recordsCache: null,
        });
        return BaseWidgetRecordMap;
    }(DataTypes_1.Record));
    exports.BaseWidgetRecordMap = BaseWidgetRecordMap;
    var DataSourceRecord = (function (_super) {
        tslib_1.__extends(DataSourceRecord, _super);
        function DataSourceRecord() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(DataSourceRecord.prototype, "dataFetchStatusAttr", {
            get: function () {
                return this.getBasicProperty(DataSourceRecord.DataFetchStatusAttributeName);
            },
            set: function (value) {
                this.setBasicProperty(DataSourceRecord.DataFetchStatusAttributeName, value, DataTypes_1.DataTypes.Integer);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DataSourceRecord.prototype, "isDataFetchedAttr", {
            get: function () {
                return this.dataFetchStatusAttr === 1;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DataSourceRecord.prototype, "hasFetchErrorAttr", {
            get: function () {
                return this.dataFetchStatusAttr === 2;
            },
            enumerable: false,
            configurable: true
        });
        DataSourceRecord.attributesToDeclare = function () {
            return [
                DataTypes_1.GenericRecord.attr("DataFetchStatus", DataSourceRecord.DataFetchStatusAttributeName, "", true, false, DataTypes_1.DataTypes.Integer, function () { return 0; }),
            ].concat(_super.attributesToDeclare.call(this));
        };
        DataSourceRecord.prototype.replaceWith = function (other) {
            var newDataSourceRecord = new this.constructor(DataTypes_1.Record.getData(other));
            newDataSourceRecord.dataFetchStatusAttr = this.dataFetchStatusAttr;
            this.writePropagate(DataTypes_1.Record.getData(newDataSourceRecord), new DataTypes_1.Cache());
        };
        DataSourceRecord.DataFetchStatusAttributeName = "dataFetchStatusAttr";
        return DataSourceRecord;
    }(DataTypes_1.GenericRecord));
    exports.DataSourceRecord = DataSourceRecord;
    var AggregateRecord = (function (_super) {
        tslib_1.__extends(AggregateRecord, _super);
        function AggregateRecord() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(AggregateRecord.prototype, "listOut", {
            get: function () {
                return this.getComplexProperty(AggregateRecord.ListOutAttributeName, this.getRecordListType());
            },
            set: function (value) {
                this.setComplexProperty(AggregateRecord.ListOutAttributeName, value, DataTypes_1.DataTypes.RecordList, this.getRecordListType());
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(AggregateRecord.prototype, "countOut", {
            get: function () {
                return this.getBasicProperty(AggregateRecord.CountOutAttributeName);
            },
            set: function (value) {
                this.setBasicProperty(AggregateRecord.CountOutAttributeName, value, DataTypes_1.DataTypes.LongInteger);
            },
            enumerable: false,
            configurable: true
        });
        AggregateRecord.prototype.bulkSet = function (listValue, dataFetchStatusValue, countValue) {
            var properties = [
                { name: AggregateRecord.ListOutAttributeName, value: listValue, isBasicType: false },
                { name: DataSourceRecord.DataFetchStatusAttributeName, value: dataFetchStatusValue, isBasicType: true },
            ];
            if (countValue !== undefined) {
                properties.push({ name: AggregateRecord.CountOutAttributeName, value: countValue, isBasicType: true });
            }
            this.setProperties(properties);
        };
        AggregateRecord.prototype.getRecordListType = function () {
            return this.constructor.RecordListType;
        };
        AggregateRecord.attributesToDeclare = function () {
            return [
                DataTypes_1.GenericRecord.attr("List", AggregateRecord.ListOutAttributeName, "List", true, false, DataTypes_1.DataTypes.RecordList, function () { return false; }, true, this.RecordListType),
                DataTypes_1.GenericRecord.attr("Count", AggregateRecord.CountOutAttributeName, "Count", true, false, DataTypes_1.DataTypes.LongInteger, function () { return DataTypes_1.LongInteger.defaultValue; }),
            ].concat(_super.attributesToDeclare.call(this));
        };
        AggregateRecord.init = function () {
            if (!this.RecordListType) {
                throw new TypeError("AggregateRecords must define a RecordListType");
            }
            _super.init.call(this);
        };
        AggregateRecord.ListOutAttributeName = "listOut";
        AggregateRecord.CountOutAttributeName = "countOut";
        return AggregateRecord;
    }(DataSourceRecord));
    exports.AggregateRecord = AggregateRecord;
    var BaseViewModel = (function (_super) {
        tslib_1.__extends(BaseViewModel, _super);
        function BaseViewModel(_context) {
            var _this = _super.call(this) || this;
            _this._context = _context;
            _this.writeSubscriptions = [];
            _this.cachedValues = {};
            _this.modified = false;
            if (_this.hasVariables) {
                _this.variables;
            }
            if (_this.hasValidationWidgets) {
                _this.widgets;
            }
            return _this;
        }
        BaseViewModel.createDefaultData = function () {
            var variablesRecord = this.newVariablesRecord();
            var widgetsRecord = this.newWidgetsRecord();
            return new BaseViewModel.RecordClass({
                variables: DataTypes_1.Record.getData(variablesRecord),
                widgets: DataTypes_1.Record.getData(widgetsRecord),
                clientVariablesGeneration: 0,
                currentLocale: null,
            });
        };
        BaseViewModel.prototype.onDefaultWritePropagate = function (arg) {
            _super.prototype.onDefaultWritePropagate.call(this, arg);
            this.modified = true;
            this.innerFlush(true);
        };
        BaseViewModel.prototype.cloneCache = function () {
            return this.cache;
        };
        Object.defineProperty(BaseViewModel.prototype, "isModified", {
            get: function () {
                return this.modified;
            },
            enumerable: false,
            configurable: true
        });
        BaseViewModel.prototype.scheduleFlush = function () {
            var _this = this;
            if (!this.pendingFlush) {
                this.pendingFlush = setTimeout(function () { return _this.flush(); }, 0);
            }
        };
        BaseViewModel.prototype.flush = function () {
            if (this.pendingFlush) {
                clearTimeout(this.pendingFlush);
                this.pendingFlush = undefined;
            }
            if (this.modified) {
                this.modified = false;
                GenerationsTree.currentGeneration++;
                this.innerFlush(false);
                Logger.trace(this, "Flushing model on ".concat(this.displayName));
            }
        };
        Object.defineProperty(BaseViewModel.prototype, "displayName", {
            get: function () {
                return "".concat(this.context.viewName).concat(this.context.componentName && this.context.componentName !== this.context.viewName
                    ? "/".concat(this.context.componentName)
                    : "");
            },
            enumerable: false,
            configurable: true
        });
        BaseViewModel.prototype.innerFlush = function (immediate) {
            for (var i = 0; i < this.writeSubscriptions.length; i++) {
                var registration = this.writeSubscriptions[i];
                if (registration.immediate === immediate) {
                    registration.handler(this);
                }
            }
        };
        BaseViewModel.prototype.subscribeWrites = function (handler, notifyImmediatly) {
            if (notifyImmediatly === void 0) { notifyImmediatly = false; }
            if (this.hasVariables ||
                this.hasValidationWidgets ||
                this.currentLocale !== null ||
                this.currentLocale !== undefined) {
                if (!!handler) {
                    this.writeSubscriptions.push({ handler: handler, immediate: notifyImmediatly });
                    return true;
                }
            }
            return false;
        };
        BaseViewModel.prototype.unsubscribeWrites = function (handler) {
            if (!!handler) {
                var idx = -1;
                for (var i = 0, l = this.writeSubscriptions.length; i < l; i++) {
                    if (this.writeSubscriptions[i].handler === handler) {
                        idx = i;
                        break;
                    }
                }
                if (idx >= 0) {
                    this.writeSubscriptions.splice(idx, 1);
                    return true;
                }
            }
            return false;
        };
        BaseViewModel.prototype.clearSubscriptions = function () {
            this.writeSubscriptions = [];
        };
        Object.defineProperty(BaseViewModel, "hasVariables", {
            get: function () {
                return true;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseViewModel.prototype, "hasVariables", {
            get: function () {
                return this.constructor.hasVariables;
            },
            enumerable: false,
            configurable: true
        });
        BaseViewModel.getVariablesRecordConstructor = function () {
            throw new Error("@abstract");
        };
        BaseViewModel.newVariablesRecord = function (data) {
            if (this.hasVariables) {
                return new (this.getVariablesRecordConstructor())(data);
            }
            else {
                return undefined;
            }
        };
        BaseViewModel.prototype.getVariables = function () {
            var classDef = this.constructor;
            if (this.hasVariables) {
                return this.getComplexProperty(BaseViewModel.VariablesPropertyName, classDef.getVariablesRecordConstructor());
            }
            else {
                throw new Error("Model does not contain variables");
            }
        };
        Object.defineProperty(BaseViewModel.prototype, "variables", {
            get: function () {
                return this.getVariables();
            },
            set: function (value) {
                var classDef = this.constructor;
                this.setComplexProperty(BaseViewModel.VariablesPropertyName, value, DataTypes_1.DataTypes.Record, classDef.getVariablesRecordConstructor());
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseViewModel.prototype, "clientVariablesGeneration", {
            get: function () {
                return this.getBasicProperty(BaseViewModel.ClientVariablesGenerationPropertyName);
            },
            set: function (value) {
                this.setBasicProperty(BaseViewModel.ClientVariablesGenerationPropertyName, value, DataTypes_1.DataTypes.Integer);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseViewModel, "hasValidationWidgets", {
            get: function () {
                return true;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseViewModel.prototype, "hasValidationWidgets", {
            get: function () {
                return this.constructor.hasValidationWidgets;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseViewModel.prototype, "currentLocale", {
            get: function () {
                return this.getBasicProperty(BaseViewModel.CurrentLocalePropertyName);
            },
            set: function (value) {
                if (this.currentLocale !== value) {
                    this.clearCachedValues();
                }
                this.setBasicProperty(BaseViewModel.CurrentLocalePropertyName, value, DataTypes_1.DataTypes.Text);
            },
            enumerable: false,
            configurable: true
        });
        BaseViewModel.getWidgetsRecordConstructor = function () {
            throw new Error("@abstract");
        };
        BaseViewModel.newWidgetsRecord = function (data) {
            if (this.hasValidationWidgets) {
                return new (this.getWidgetsRecordConstructor())(data);
            }
            else {
                return undefined;
            }
        };
        BaseViewModel.prototype.getWidgets = function () {
            var classDef = this.constructor;
            if (this.hasValidationWidgets) {
                return this.getComplexProperty(BaseViewModel.WidgetsPropertyName, classDef.getWidgetsRecordConstructor());
            }
            else {
                throw new Error("Model does not contain validation widgets");
            }
        };
        Object.defineProperty(BaseViewModel.prototype, "widgets", {
            get: function () {
                return this.getWidgets();
            },
            set: function (value) {
                this.setComplexProperty(BaseViewModel.WidgetsPropertyName, value, DataTypes_1.DataTypes.Object);
            },
            enumerable: false,
            configurable: true
        });
        BaseViewModel.prototype.hasCachedValue = function (key) {
            return this.cachedValues.hasOwnProperty(key);
        };
        BaseViewModel.prototype.getCachedValue = function (key, getValue) {
            var deferredArgs = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                deferredArgs[_i - 2] = arguments[_i];
            }
            var expr = this.cachedValues[key];
            var valueArgs = deferredArgs.map(function (deferred, i) {
                try {
                    return deferred();
                }
                catch (ex) {
                    return BaseViewModel.InvalidValue;
                }
            });
            var useCachedValue = expr !== undefined &&
                deferredArgs.length === expr.args.length &&
                valueArgs.every(function (e, i) { return e === expr.args[i]; });
            if (!useCachedValue) {
                expr = { args: valueArgs, value: getValue() };
                this.cachedValues[key] = expr;
            }
            return expr.value;
        };
        BaseViewModel.prototype.clearCachedValues = function () {
            this.cachedValues = {};
        };
        BaseViewModel.prototype.createVariable = function (type, defaultValue, setter) {
            return new Variable(type, defaultValue, setter, this);
        };
        BaseViewModel.prototype.fromOther = function (otherModel) {
            this.fromImmutableData(otherModel.data);
        };
        BaseViewModel.prototype.toImmutableData = function () {
            return this.data;
        };
        BaseViewModel.prototype.fromImmutableData = function (data) {
            this.data = data;
            this.writePropagate(this.data, this.cache);
            this.cache.invalidate();
        };
        BaseViewModel.prototype.setInputs = function (obj) {
            throw new Error("@abstract");
        };
        Object.defineProperty(BaseViewModel.prototype, "widgetsGenerationsTree", {
            get: function () {
                if (!this._widgetsGenerationsTree) {
                    this._widgetsGenerationsTree = new GenerationsTree();
                }
                return this._widgetsGenerationsTree;
            },
            enumerable: false,
            configurable: true
        });
        BaseViewModel.prototype.getReadOnlyWidgetRecord = function (widgetId) {
            return this.widgets.get(widgetId).asReadOnly();
        };
        Object.defineProperty(BaseViewModel.prototype, "context", {
            get: function () {
                return this._context;
            },
            enumerable: false,
            configurable: true
        });
        BaseViewModel.prototype.sanitize = function (data) {
            var newData = data;
            if (this.hasVariables) {
                if (data.constructor !== this.data.constructor) {
                    throw new Error("Expected data to be the same type of this model data");
                }
                var nonSerializableAttributes = this.variables.getNonSerializableAttributes();
                if (nonSerializableAttributes.length > 0) {
                    var variables_1 = newData.get(BaseViewModel.VariablesPropertyName);
                    nonSerializableAttributes.forEach(function (a) { return (variables_1 = variables_1.set(a, null)); });
                    newData = newData.set(BaseViewModel.VariablesPropertyName, variables_1);
                }
            }
            return newData;
        };
        BaseViewModel.VariablesPropertyName = "variables";
        BaseViewModel.WidgetsPropertyName = "widgets";
        BaseViewModel.ClientVariablesGenerationPropertyName = "clientVariablesGeneration";
        BaseViewModel.CurrentLocalePropertyName = "currentLocale";
        BaseViewModel.InvalidValue = new Object();
        BaseViewModel.RecordClass = DataTypes_1.Record.defineRecordClass({
            variables: null,
            widgets: null,
            clientVariablesGeneration: 0,
            currentLocale: null,
        });
        return BaseViewModel;
    }(DataTypes_1.Record));
    exports.BaseViewModel = BaseViewModel;
    function calculateDataFetchStatus() {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        var status = 1;
        for (var _a = 0, values_1 = values; _a < values_1.length; _a++) {
            var value = values_1[_a];
            switch (value) {
                case 2:
                    return 2;
                case 0:
                    status = 0;
                    break;
                default:
                    break;
            }
        }
        return status;
    }
    exports.calculateDataFetchStatus = calculateDataFetchStatus;
    var VariablelessViewModel = (function (_super) {
        tslib_1.__extends(VariablelessViewModel, _super);
        function VariablelessViewModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(VariablelessViewModel, "hasVariables", {
            get: function () {
                return false;
            },
            enumerable: false,
            configurable: true
        });
        VariablelessViewModel.prototype.setInputs = function () { };
        return VariablelessViewModel;
    }(BaseViewModel));
    exports.VariablelessViewModel = VariablelessViewModel;
    var DummyViewModel = (function (_super) {
        tslib_1.__extends(DummyViewModel, _super);
        function DummyViewModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(DummyViewModel, "hasVariables", {
            get: function () {
                return false;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DummyViewModel, "hasValidationWidgets", {
            get: function () {
                return false;
            },
            enumerable: false,
            configurable: true
        });
        DummyViewModel.prototype.setInputs = function () { };
        DummyViewModel.create = function (viewName, componentName, navigatedFromHistory, viewWasRestoredFromCache) {
            return new DummyViewModel({
                viewName: viewName,
                componentName: componentName,
                navigatedFromHistory: navigatedFromHistory,
                viewWasRestoredFromCache: viewWasRestoredFromCache,
            });
        };
        return DummyViewModel;
    }(BaseViewModel));
    exports.DummyViewModel = DummyViewModel;
    var ModelFactory = (function () {
        function ModelFactory(modelClass, componentName) {
            if (componentName === void 0) { componentName = ""; }
            this.modelClass = modelClass;
            this.componentName = componentName;
        }
        ModelFactory.prototype.create = function (context) {
            if (context) {
                context.componentName = this.componentName;
            }
            if (!this.modelClass.hasVariables && !this.modelClass.hasValidationWidgets) {
                return new DummyViewModel(context);
            }
            return new this.modelClass(context);
        };
        Object.defineProperty(ModelFactory.prototype, "hasValidationWidgets", {
            get: function () {
                return this.modelClass.hasValidationWidgets;
            },
            enumerable: false,
            configurable: true
        });
        return ModelFactory;
    }());
    exports.ModelFactory = ModelFactory;
    var GenerationNode = (function () {
        function GenerationNode(_parent) {
            this._parent = _parent;
            this._generation = _parent ? _parent.generation : 0;
        }
        Object.defineProperty(GenerationNode.prototype, "parent", {
            get: function () {
                return this._parent;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GenerationNode.prototype, "generation", {
            get: function () {
                return this._generation;
            },
            set: function (value) {
                if (this.generation < value) {
                    this._generation = value;
                    if (this.parent) {
                        this.parent.generation = value;
                    }
                }
            },
            enumerable: false,
            configurable: true
        });
        GenerationNode.prototype.addChild = function () {
            return new GenerationNode(this);
        };
        return GenerationNode;
    }());
    var GenerationsTree = (function () {
        function GenerationsTree() {
            this._root = new GenerationNode(null);
            this._root.generation = GenerationsTree.currentGeneration;
            GenerationsTree.currentGeneration++;
        }
        Object.defineProperty(GenerationsTree.prototype, "root", {
            get: function () {
                return this._root;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GenerationsTree, "currentGeneration", {
            get: function () {
                return GenerationsTree.generation;
            },
            set: function (value) {
                GenerationsTree.generation = value;
            },
            enumerable: false,
            configurable: true
        });
        GenerationsTree.generation = 0;
        return GenerationsTree;
    }());
});
//# sourceMappingURL=Model.js.map;
